import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SecoundSection from './Sections/section2Banner';
import ThirdSection from './Sections/Section3Banner';
import FourthSection from './Sections/Section4Banner';
import FifthSection from './Sections/Section5Banner';
import HeroCarousel from './Sections/HeroCoarsel';
import Partners from './Sections/Partners';
import HeroSectionPrime from '../../components/HeroSectionPrime';


const Home = () => {
  const { firstSectionRef } = useOutletContext();

  return (
    <div className="App-header">
      <div ref={firstSectionRef}>
        {/* <HeroBanner /> */}
      {/* <HeroSectionPrime
        imgSrc={require("../../assets/Hero/Image1.png")}
        Align={"text-center"}
        lineHeight={"leading-loose"}
        btnAppear={true}
        title={<h1>Empowering Healthcare Excellence in Egypt</h1>}
        content={<p>H2A Medical Solutions aims to provide advanced, comprehensive, and sustainable healthcare solutions to all healthcare providers, both public and private, in Egypt. With a strong focus on quality, excellence, and trust, H2A empowers healthcare providers to offer distinctive services and improve patient diagnostic outcomes and experiences. The company is committed to customer satisfaction and success, offering top-notch education, technical support, and post-sales services to ensure customer loyalty and satisfaction.</p>}
      /> */}
        <HeroCarousel/>
      </div>
      <Partners/>
      <SecoundSection/>
      {/* <SecoundSectionAccumelator/> */}
      <ThirdSection/>
      {/* <FourthSection/> */}
      <FifthSection/>

    </div>
  );
};

export default Home;
